import styled from 'styled-components';

export const StyledLineItem = styled.div`
    display: flex;
    padding: 12px 16px 12px 12px;
    justify-content: space-between;
    align-items: center;
    align-self: stretch;

    &:nth-child(odd) {
        background-color: #f1f1f2;
    }
`;

export const StyledLabelWithTooltip = styled.span`
    display: flex;
    gap: 5px;
`;
